import { CircleButton } from "v2/components/base/Button/ui";
import { withClose } from "../base/Button/hocs/withClose";
import { withVersions } from "v2/hocs/withVersions";
import { ReactComponent as CloseIcon } from "assets/icons/close-v2.svg";

const CloseButtons = withVersions({
  v1: withClose(CircleButton),
  v2: withClose(CircleButton),
});

const CloseButton = (props: any) => {
  return (
    <CloseButtons {...props}>
      {props.children ? props.children : <CloseIcon width={16} height={16} />}
    </CloseButtons>
  );
};

export default CloseButton;
